import { useAtom } from "jotai";
import React, { useState } from "react";
import { Button } from "../components/Button";
import { currentUserAtom } from "../jotai/atoms";
import { logout } from "../auth";

export default function LogOutButton({
  redirect,
  style,
}: {
  redirect?: string;
  style?: React.CSSProperties;
}) {
  const [currentUser] = useAtom(currentUserAtom);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  return (
    <>
      {currentUser ? (
        <Button
          style={{ fontWeight: "bold", ...style }}
          onClick={() => {
            setIsLoggingOut(true);
            logout(redirect);
          }}
        >
          {isLoggingOut ? "Logging out..." : "Log out"}
        </Button>
      ) : null}
    </>
  );
}
